import { fetchMsmePaymentDelays } from './service';
import { toMsmeDelayGraph } from './mappers';
import { loadCachedBefeData } from './loadCachedBefeData';
import { BEFE_SERVICE_IDS } from './constants';
import type { MsmeDelayGraph, UwMsmePaymentDelaysData } from './types';

/** The MSME graph of the current org only, shared by the vendor-table pills and replaced by every MSME card fetch. */
const graphCache = new Map<string, Promise<MsmeDelayGraph | null>>();

function keepOnlyOrg(orgId: string): void {
    if (!graphCache.has(orgId)) graphCache.clear();
}

/** One request per org; a failure is evicted so the next call retries. */
export function loadMsmeDelayGraph(orgId: string): Promise<MsmeDelayGraph | null> {
    keepOnlyOrg(orgId);
    return loadCachedBefeData<UwMsmePaymentDelaysData, MsmeDelayGraph>(
        graphCache,
        orgId,
        () => fetchMsmePaymentDelays(orgId),
        BEFE_SERVICE_IDS.MSME_PAYMENT_DELAYS,
        toMsmeDelayGraph,
    );
}

/** The MSME card's fetch: drops any earlier graph so pills share this request and never outlive a failed refresh. */
export function refreshMsmeDelayGraph(orgId: string): Promise<MsmeDelayGraph | null> {
    graphCache.clear();
    return loadMsmeDelayGraph(orgId);
}
